<template>
    <div class="zxstudy">
        <p class="top-title">您的当前位置：{{ "在线课程" }}</p>
        <div class="video-box">
            <p class="video-active-title">
                正在播放：{{ videoActive.coursetitle }}
            </p>
            <video
                :src="videoActive && videoActive.video"
                controlsList="nodownload"
                controls
            ></video>
        </div>
        <p class="video-bottom flex-row">
            <span>分享到：微信</span>
            <span class="score flex-row">
                <span>评分：</span>
                <span
                    class="iconfont"
                    v-html="
                        courseData.coursesSeries.totalScore == 0
                            ? '&#xe6b6;'
                            : courseData.coursesSeries.totalScore >= 1
                            ? '&#xe607;'
                            : '&#xe6b7;'
                    "
                ></span>
                <span
                    class="iconfont"
                    v-html="
                        courseData.coursesSeries.totalScore <= 1
                            ? '&#xe6b6;'
                            : courseData.coursesSeries.totalScore >= 2
                            ? '&#xe607;'
                            : '&#xe6b7;'
                    "
                ></span>
                <span
                    class="iconfont"
                    v-html="
                        courseData.coursesSeries.totalScore <= 2
                            ? '&#xe6b6;'
                            : courseData.coursesSeries.totalScore >= 3
                            ? '&#xe607;'
                            : '&#xe6b7;'
                    "
                ></span>
                <span
                    class="iconfont"
                    v-html="
                        courseData.coursesSeries.totalScore <= 3
                            ? '&#xe6b6;'
                            : courseData.coursesSeries.totalScore >= 4
                            ? '&#xe607;'
                            : '&#xe6b7;'
                    "
                ></span>
                <span
                    class="iconfont"
                    v-html="
                        courseData.coursesSeries.totalScore <= 4
                            ? '&#xe6b6;'
                            : courseData.coursesSeries.totalScore >= 5
                            ? '&#xe607;'
                            : '&#xe6b7;'
                    "
                ></span>
                <span class="score-text">{{
                    courseData.coursesSeries.totalScore
                }}</span>
            </span>
        </p>
        <div class="content clearfix">
            <div class="con-left">
                <div class="tab-title flex-row">
                    <div
                        @click="changeTab(1)"
                        :class="[
                            activeTab == 1 ? 'title-item-active' : '',
                            'title-item',
                            'flex-col'
                        ]"
                    >
                        <img src="../../../static/img/mulu.png" />
                        <span>课程目录</span>
                    </div>
                    <div
                        @click="changeTab(2)"
                        :class="[
                            activeTab == 2 ? 'title-item-active' : '',
                            'title-item',
                            'flex-col'
                        ]"
                        class="title-item flex-col"
                    >
                        <img src="../../../static/img/note.png" />
                        <span>课程笔记</span>
                    </div>
                    <div
                        @click="changeTab(3)"
                        :class="[
                            activeTab == 3 ? 'title-item-active' : '',
                            'title-item',
                            'flex-col'
                        ]"
                        class="title-item flex-col"
                    >
                        <img src="../../../static/img/score.png" />
                        <span>我要评分</span>
                    </div>
                </div>
                <div v-show="activeTab == 1" class="tab-detail-box">
                    <div
                        @click="changeActiveVideo(item)"
                        v-for="(item, index) in courseData.muluList"
                        :key="index"
                        class="mulu-item flex-row"
                    >
                        <img :src="item.imge" :alt="item.coursetitle" />
                        <span class="mulu-title">{{
                            index + 1 + "." + item.coursetitle
                        }}</span>
                        <span class="mulu-time">
                            上传时间{{
                                item.releasetime &&
                                    item.releasetime.time | dateFormat
                            }}
                        </span>
                    </div>
                </div>
                <div v-show="activeTab == 2" class="tab-detail-box">
                    <textarea
                        v-model="noteText"
                        class="note-str"
                        name="notestr"
                    ></textarea>
                    <div @click="submitNoteScore(2)" class="note-btn">
                        提交笔记
                    </div>
                </div>
                <div v-show="activeTab == 3" class="tab-detail-box">
                    <p class="score-title">我要给课程打分：</p>
                    <div class="score-star-box flex-row">
                        <span
                            @mouseover="changeScore(1)"
                            @mouseout="hideScore"
                            :class="[
                                scoreNum >= 1 ? 'star-active' : '',
                                'iconfont'
                            ]"
                            v-html="scoreNum >= 1 ? '&#xe607;' : '&#xe6b6;'"
                            @click="change(1)"
                        >
                        </span>
                        <span
                            @mouseover="changeScore(2)"
                            @mouseout="hideScore"
                            :class="[
                                scoreNum >= 2 ? 'star-active' : '',
                                'iconfont'
                            ]"
                            v-html="scoreNum >= 2 ? '&#xe607;' : '&#xe6b6;'"
                            @click="change(2)"
                        >
                        </span>
                        <span
                            @mouseover="changeScore(3)"
                            @mouseout="hideScore"
                            :class="[
                                scoreNum >= 3 ? 'star-active' : '',
                                'iconfont'
                            ]"
                            v-html="scoreNum >= 3 ? '&#xe607;' : '&#xe6b6;'"
                            @click="change(3)"
                        >
                        </span>
                        <span
                            @mouseover="changeScore(4)"
                            @mouseout="hideScore"
                            :class="[
                                scoreNum >= 4 ? 'star-active' : '',
                                'iconfont'
                            ]"
                            v-html="scoreNum >= 4 ? '&#xe607;' : '&#xe6b6;'"
                            @click="change(4)"
                        >
                        </span>
                        <span
                            @mouseover="changeScore(5)"
                            @mouseout="hideScore"
                            :class="[
                                scoreNum >= 5 ? 'star-active' : '',
                                'iconfont'
                            ]"
                            v-html="scoreNum >= 5 ? '&#xe607;' : '&#xe6b6;'"
                            @click="change(5)"
                        >
                        </span>
                    </div>
                    <p class="text-tips">点击星星进行打分</p>
                    <p class="star-btn" @click="submitNoteScore(1)">提交打分</p>
                </div>
            </div>
            <div class="con-right">
                <h2>相关推荐</h2>
                <div
                    @click="goDetails(item)"
                    v-for="(item, index) in tuiData"
                    :key="index"
                    class="xg-item"
                >
                    <div class="pic-box">
                        <img :src="item.cover" :alt="item.totalTitle" />
                    </div>
                    <p class="title">
                        {{
                            item.totalTitle.length > 25
                                ? item.totalTitle.substring(0, 25) + "..."
                                : item.totalTitle
                        }}
                    </p>
                    <!-- <p class="teacher">讲师：xxx老师</p> -->
                </div>
            </div>
        </div>
        <transition
            enter-active-class="fadeInDown"
            leave-active-class="fadeOutUp"
        >
            <div v-show="errorTag" class="toast-box animated">
                {{ errorText }}
            </div>
        </transition>
    </div>
</template>

<script>
import { clearTimeout, setTimeout, clearInterval, setInterval } from "timers";
export default {
    name: "zxstudy",
    data() {
        return {
            detailData: {
                totalScore: 4.1
            },
            scoreNum: 0,
            changeed: false,
            activeTab: 1,
            tuiData: [],
            courseData: {
                muluList: [],
                coursesSeries: {},
                coursesStudy: {
                    totalScore: 0
                }
            },
            noteText: "",

            videoActive: {},
            errorTag: false,
            errorText: "",
            timmer: null,
            studyData: {
                time: "",
                timmer: null
            }
        };
    },
    created() {
        // if (!this.$store.state.hasLogin) {
        //     this.$router.push({
        //         name: "login"
        //     });
        // }
        this.getDetailData(this.$route.query.id);
        this.getTuiData();
        this.getTimeOutTime();
    },
    methods: {
        getTimeOutTime() {
            this.$ajax({
                url: "homePage/creditSetting",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.studyData.time =
                            parseInt(res.message.learnTimeCount) * 60 * 1000;

                        if (parseInt(res.message.learnTimeCount) > 0) {
                            this.setScore();
                        }
                    }
                }
            });
        },
        setScore() {
            if (this.studyData.timmer) {
                clearInterval(this.studyData.timmer);
                this.studyData.timmer = null;
            }
            this.studyData.timmer = setInterval(() => {
                console.log("增加学分");
                this.$ajax({
                    url: "homePage/creditSave",
                    data: {
                        token: this.$store.state.userToken
                    },
                    success: res => {},
                    error: res => {}
                });
            }, this.studyData.time);
        },
        removeScore() {
            if (this.studyData.timmer) {
                clearInterval(this.studyData.timmer);
                this.studyData.timmer = null;
            }
        },
        showErr(text) {
            if (this.timmer) {
                clearTimeout(this.timmer);
                this.timmer = null;
                this.errorTag = false;
            }
            this.errorTag = true;
            this.errorText = text;
            this.timmer = setTimeout(() => {
                this.errorTag = false;
                clearTimeout(this.timmer);
                this.timmer = null;
            }, 2000);
        },
        getDetailData(id) {
            if (id) {
                this.$ajax({
                    method: "post",
                    url: "homePage/coursesStudy",
                    data: {
                        token: this.$store.state.userToken,
                        coursesSeriesId: id
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.courseData.muluList = res.courses;
                            this.courseData.coursesSeries = res.coursesSeries;
                            this.courseData.coursesStudy = res.coursesStudy;
                            this.noteText = res.coursesStudy.notebook;
                            this.videoActive = res.courses[0];
                        }
                    },
                    error: () => {}
                });
            }
        },
        changeScore(index) {
            if (!this.changeed) {
                this.scoreNum = index;
            }
        },
        hideScore() {
            if (!this.changeed) {
                this.scoreNum = 0;
            }
        },
        change(index) {
            this.scoreNum = index;
            this.changeed = true;
        },
        changeTab(index) {
            this.activeTab = index;
        },
        getTuiData() {
            this.$ajax({
                method: "post",
                url: "homePage/getCoursesSeries",
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : "";
                        this.tuiData = res.message.records;
                    }
                },
                error: res => {}
            });
        },
        goDetails(item) {
            this.$router.push({
                name: "classDetails",
                query: { id: item.id, t1: "在线课程" }
            });
        },
        changeActiveVideo(item) {
            this.videoActive = item;
        },
        submitNoteScore(type) {
            if (type == 1) {
                if (!this.changeed) {
                    this.showErr("请先打分");
                    return;
                }
                this.$ajax({
                    url: "homePage/coursesScore",
                    methods: "post",
                    data: {
                        token: this.$store.state.userToken,
                        score: this.scoreNum,
                        id: this.courseData.coursesStudy.id
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.showErr("打分成功");
                        }
                    },
                    error: () => {}
                });
            } else {
                if (this.noteText.length == 0) {
                    this.showErr("请先输入笔记");
                    return;
                }
                this.$ajax({
                    url: "homePage/coursesScore",
                    methods: "post",
                    data: {
                        token: this.$store.state.userToken,
                        notebook: this.noteText,
                        id: this.courseData.coursesStudy.id
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.showErr("上传成功");
                        }
                    },
                    error: () => {}
                });
            }
        }
    },
    destroyed() {
        this.removeScore();
    },
    watch: {
        "$store.state.hasLogin": function(nval) {
            if (!nval) {
                this.$router.push({
                    name: "login"
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.zxstudy {
    width: 1000px;
    min-height: 500px;
    margin: 0 auto;
    .top-title {
        color: #999;
        font-size: 16px;
    }
    .video-box {
        margin-top: 15px;
        width: 1000px;
        height: 580px;
        background-color: #000;
        position: relative;
        overflow: hidden;
        .video-active-title {
            position: absolute;
            top: -30px;
            left: 0;
            transition: all ease 0.5s;
            z-index: 10;
            width: 980px;
            padding: 0 10px;
            white-space: nowrap;
            overflow: hidden;
            line-height: 30px;
            height: 30px;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.5);
        }
        video {
            width: 100%;
            height: 100%;
        }
    }
    .video-box:hover {
        .video-active-title {
            top: 0px;
        }
    }
    .video-bottom {
        padding: 10px 0;
        justify-content: space-between;
        .score {
            align-items: center;
            .iconfont {
                font-size: 18px;
                line-height: 18px;
                color: #6ac0e8;
            }
            .score-text {
                padding-left: 10px;
                color: #6ac0e8;
            }
        }
    }
    .content {
        margin-top: 20px;
        width: 1000px;
        .con-left {
            width: 720px;
            float: left;
            min-height: 420px;
            // tab
            .tab-title {
                height: 90px;
                border-bottom: 1px solid #ddd;
                .title-item {
                    display: inline-block;
                    height: 90px;
                    width: 90px;
                    margin-right: 10px;
                    background-color: #dddddd;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                    cursor: pointer;
                    img {
                        height: 30px;
                        width: 30px;
                        display: block;
                        margin: 15px auto 0;
                        vertical-align: middle;
                    }
                    span {
                        display: block;
                        text-align: center;
                        line-height: 30px;
                    }
                }
                .title-item:hover {
                    background-color: #353535;
                    span {
                        color: #fff;
                    }
                }
                .title-item-active {
                    background-color: #353535;
                    span {
                        color: #fff;
                    }
                }
            }
            .tab-detail-box {
                width: 720px;
                .mulu-item {
                    width: 100%;
                    padding: 10px 0;
                    cursor: pointer;
                    img {
                        width: 110px;
                        height: 70px;
                        border: 1px solid #ddd;
                    }
                    span {
                        color: #333333;
                    }
                    span:nth-child(2) {
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        padding: 0 20px;
                    }
                }
                .mulu-item:hover {
                    background-color: rgb(248, 248, 248);
                }
                // 课程笔记
                .note-str {
                    margin: 10px 0;
                    width: 700px;
                    height: 300px;
                    padding: 10px;
                    font-size: 16px;
                    resize: none;
                    border: 1px solid #bbb;
                }
                .note-btn {
                    background-color: #6ac0e8;
                    color: #fff;
                    width: 100px;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all ease 0.2s;
                }
                .note-btn:hover {
                    color: #333;
                }
                // 打分
                .score-title {
                    padding: 10px 20px;
                    font-size: 18px;
                }
                .score-star-box {
                    width: 400px;
                    margin: 0 auto;
                    justify-content: space-around;
                    span {
                        font-size: 60px;
                        color: #333;
                        flex: 1;
                        text-align: center;
                        cursor: pointer;
                        transition: all ease 0.2s;
                    }
                    .star-active {
                        color: #6ac0e8;
                    }
                }
                .text-tips {
                    text-align: center;
                    margin: 20px 0;
                }
                .star-btn {
                    width: 100px;
                    margin: 10px auto;
                    background-color: #6ac0e8;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                    color: #fff;
                    border-radius: 4px;
                    cursor: pointer;
                }
                .star-btn:hover {
                    color: #333;
                }
            }
        }
        .con-right {
            width: 242px;
            float: right;
            h2 {
                font-size: 16px;
                margin-bottom: 10px;
            }
            .xg-item {
                margin-bottom: 10px;
                cursor: pointer;
                .pic-box {
                    width: 240px;
                    height: 162px;
                    border: 1px solid #ddd;
                    overflow: hidden;
                    img {
                        width: 100%;
                        min-height: 100%;
                    }
                }
                .teacher {
                    color: #666;
                }
            }
        }
    }
}
.toast-box {
    width: 200px;
    height: 50px;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.8);
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 50%;
    margin-left: -100px;
    top: 300px;
    border-radius: 25px;
    color: #fff;
    text-align: center;
    line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/zxkc/study.vue